import React from "react";
import Reservation from "../../Component/Reservations";

export default function GeneralReservation({ reservationMode = "예약" }) {
  return <Reservation type="일반" reservationMode={reservationMode} />;
}
